/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable sonarjs/cognitive-complexity */

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { LoadingController, ModalController } from '@ionic/angular/standalone'
import { TranslateService } from '@ngx-translate/core'
import { CacheService } from '../../../../src/commons/services/business/cache.service'
import { UserClaims } from '../../../../src/commons/enums/user-claims.enum'
import { PlatformService } from '../../../commons/services/business/platform.service'
import { UserApiService } from '../../../../src/security/models/services/users/userApi.service'
import { AuthWrapperService } from '../../../../src/security/models/services/auth'
import { AppUserClaims, OrgRoleDto } from '../../../../src/security/models'

@Component({
  selector: 'app-user-permissions',
  templateUrl: './user-permissions.component.html',
  styleUrls: ['./user-permissions.component.scss'],
})
export class UserPermissionsComponent implements OnInit {
  @Input() userId: number
  @Input() orgId: number
  @Input() readonly = true

  @Input() roles: number[]
  @Output() rolesChange: EventEmitter<number[]> = new EventEmitter<number[]>()

  @Input() claims: number[]
  @Output() claimsChange: EventEmitter<number[]> = new EventEmitter<number[]>()

  public error = null
  public claimsCount = 0
  public rolesCount = 0

  public permissions = {
    roles: [],
    claims: [],
  }
  public currentContent = 'roles'

  private loading
  private _isInternalOrg = false
  private _isInternalUser = false

  constructor(
    public platform: PlatformService,
    public modalController: ModalController,
    public userApiService: UserApiService,
    public loadingController: LoadingController,
    private cacheService: CacheService,
    private authWrapper: AuthWrapperService,
    private readonly translate: TranslateService
  ) { }

  async ngOnInit(): Promise<void> {
    await this.load()
  }

  get selectedRoles(): number[] {
    const roles = []
    this.permissions?.roles.forEach((r) => {
      if (r.isSelected) {
        roles.push(r.rId)
      }
    })

    return roles
  }

  get selectedClaims(): number[] {
    const claims = []
    this.permissions.claims?.forEach((cg) => {
      cg.claims.forEach((c) => {
        if (c.isSelected) {
          claims.push(c.rId)
        }
      })
    })

    return claims
  }

  public async load(): Promise<void> {
    try {
      this._isInternalOrg = await this.cacheService.isInternalOrg()
      this._isInternalUser = this.authWrapper.isInternalUser()

      const userInfo = await this.cacheService.getUserInfo()
      await this.presentLoading()

      if (this.userId) {
        if (this.userId === userInfo?.rId) {
          //An Admin user may NOT edit their own Roles/Claims
          this.readonly = true
        }

        //we need to get first the User assigned permissions
        const userPermissions = await this.userApiService.getUserPermissions(this.userId)
        //we now get the Org permissions
        this.permissions = await this.userApiService.getPermissionsByOrgId()
        //we populate fields based on the user permission set
        this.roles = userPermissions.roles.map((r) => r.rId)
        this.claims = userPermissions.claims.map((c) => c.rId)

        if (!this.readonly && !this._isInternalUser) {
          //An Admin user may NOT edit the Roles/Claims of another admin user. (Admin user is anyone who has the "edit user" or "create new user" claim permissions).
          this.readonly =
            userPermissions.claims.filter((c) => c.key === UserClaims.EditUser || c.key === UserClaims.InviteNewUser)
              .length > 0
        }
      } else {
        if (this.permissions.claims.length == 0) {
          this.permissions = await this.userApiService.getPermissionsByOrgId()
        }
      }

      const claims = []
      this.permissions.claims.forEach(
        ((hash) => {
          return (claimConfiguration) => {
            if (!hash[claimConfiguration.claimGroupName]) {
              hash[claimConfiguration.claimGroupName] = {
                claimGroupName: claimConfiguration.claimGroupName,
                claims: [],
                isSelected: false,
                isActive: true,
                disableGrantOption: claimConfiguration.disableGrantOption
              }
              claims.push(hash[claimConfiguration.claimGroupName])
            }

            hash[claimConfiguration.claimGroupName].claims.push({
              rId: claimConfiguration.rId,
              key: claimConfiguration.key,
              principalClaims: claimConfiguration.principalClaims,
              displayName: claimConfiguration.displayName,
              isSelected: this.claims?.indexOf(claimConfiguration.rId) >= 0,
              isActive: true,
              disableGrantOption: claimConfiguration.disableGrantOption
            })

            hash[claimConfiguration.claimGroupName].isSelected =
              hash[claimConfiguration.claimGroupName].claims.filter((c) => !c.isSelected).length == 0
            hash[claimConfiguration.claimGroupName].selectedClaims = hash[
              claimConfiguration.claimGroupName
            ].claims.filter((c) => c.isSelected).length
          }
        })(Object.create(null))
      )

      this.permissions.claims = claims

      this.permissions.roles.forEach((r) => {
        r.isSelected = this.roles.indexOf(r.rId) >= 0
        if (r.isSelected) {
          this.rolesCount++
        }
      })

      this.checkClaimGroups()
    } catch (err) {
      this.error = err
    } finally {
      await this.dismissLoading()
    }
  }

  public get hasClaims(): boolean {
    return this.claimsCount === 0
  }

  private checkClaimGroups(): void {
    this.claimsCount = 0
    this.permissions.claims.forEach((cg) => {
      const unselected = cg.claims.filter((c) => !c.isSelected).length
      cg.selectedClaims = cg.claims.length - unselected

      //will update the group only when all the inner elements are unselected
      //setting a timeout so it will give time to react
      setTimeout(() => {
        cg.isSelected = cg.selectedClaims > 0
      }, 100)

      //updating the selected Claims count
      this.claimsCount += cg.selectedClaims
    })
    //updating fields and notifying
    this.claims = this.selectedClaims
    this.claimsChange.emit(this.claims)
    this.roles = this.selectedRoles
    this.rolesChange.emit(this.roles)
  }

  public toggleRole(role, event): void {
    role.claims?.forEach((rc) => {
      //roles has claims, when you select a role you will not be able to toggle the related claims
      this.permissions.claims.forEach((cg) => {
        cg.claims.forEach((c) => {
          if (c.rId == rc.rId) {
            c.isSelected = event.detail.checked
            c.isActive = !event.detail.checked
          }
        })
      })
    })

    //updating the selected Role count
    this.rolesCount = this.permissions.roles?.filter((r) => r.isSelected).length

    this.checkClaimGroups()
  }

  public toggleClaimGroup(claimGroup, event): void {
    if (claimGroup.isSelected == event.detail.checked) {
      return
    }

    if (!event.detail.checked) {
      claimGroup.isSelected = false
      if (claimGroup.claims.filter(c => c.isActive).length == 0) {
        setTimeout(() => {
          claimGroup.isSelected = true
        }, 200)
      }
    }

    claimGroup.claims?.forEach((c) => {
      if (c.isActive) {
        c.isSelected = event.detail.checked
      }
    })

    this.checkClaimGroups()
  }

  public toggleClaim(claim, event): void {
    if (claim.isActive) {
      if (event.detail.checked) {
        //checks for principal claims, if they are not selected, then select it
        this.checkPrincipalClaims(claim)
      } else {
        //we need to uncheck other claims if this one is a principal claim for others
        this.uncheckDependentClaims(claim)
      }
      claim.isSelected = event.detail.checked
    }
    this.checkClaimGroups()
  }

  private checkPrincipalClaims(claim: any) {
    claim?.principalClaims.forEach((pc) => {
      this.permissions.claims.forEach((cg) => {
        cg?.claims.forEach((c) => {
          if (c.rId === pc && !c.isSelected) {
            c.isSelected = true
          }
        })
      })
    })
  }

  private uncheckDependentClaims(claim: any) {
    this.permissions.claims.forEach((cg) => {
      cg?.claims.forEach((c) => {
        if (c.principalClaims.indexOf(claim.rId) >= 0) {
          c.isSelected = false
        }
      })
    })
  }

  public segmentChanged(event): void {
    this.currentContent = event.detail.value
  }

  private async presentLoading() {
    this.loading = await this.loadingController.create({
      message: this.translate.instant('administration.loading'),
    })
    await this.loading.present()
  }

  private async dismissLoading() {
    await this.loading.dismiss()
  }

  public checkDisableGrantOptionForRole(role: OrgRoleDto) {
    return (role.claims.some(q => q.disableGrantOption) && !this._isInternalUser && !this._isInternalOrg) ||
      (role.claims.some(q => q.disableGrantOption) && this._isInternalOrg)
  }

  public checkDisableGrantOptionForClaim(claim: AppUserClaims) {
    return (claim.disableGrantOption && !this._isInternalUser && !this._isInternalOrg) ||
      (claim.disableGrantOption && this._isInternalOrg)
  }

  public checkDisableIfRoleIsAssigned(claim: any, isRoleGroup = false) {
    const role = this.permissions.roles.find(q => q.name == claim.claimGroupName)

    if (!isRoleGroup)
      return role && role.isSelected && role.claims.some(q => q.key == claim.key)
    else
      return role && role.isSelected
  }
}
